import {
  SET_FETCH_STATUS,
  SET_FETCH_DEFAULTS,
  REQUEST_STATE,
  SET_FETCH_LOADING,
  LOAD_IO_STATE_BY_BOOK_ID,
  IMAGES_LOADING,
  AUTOFILL_FINISHED,
  CONVERT_FINISHED,
} from './../../action-types/entities/io';

export const STATE_KEY = 'io';

export const io = (state = {
  imagesLoaded: false,
  autofillFinished: false,
  convertFinished: false,
  fetchState: {},
}, action) => {
  switch (action.type) {
    case LOAD_IO_STATE_BY_BOOK_ID: {
      return action.bookstate;
    }

    case SET_FETCH_DEFAULTS: {
      const fetchDefaults = {
        autofillFinished: false,
        fetchState: {
          isLoading: false,
          status: 'OK',
        },
      };
      const fetchDetails = Object.assign({}, fetchDefaults, action.cover);
      return fetchDetails;
    }

    case SET_FETCH_LOADING: {
      const { isLoading } = action;
      return {
        ...state,
        fetchState: {
          ...state.fetchState,
          isLoading,
        },
      };
    }

    case SET_FETCH_STATUS: {
      const { status } = action;
      return {
        ...state,
        fetchState: {
          ...state.fetchState,
          status,
        },
      };
    }

    case REQUEST_STATE: {
      return {
        ...state,
        fetchState: {
          ...state.fetchState,
          isLoading: true,
          status: '',
        },
      };
    }

    case IMAGES_LOADING: {
      const { status } = action;
      return {
        ...state,
        imagesLoaded: status,
      };
    }

    case AUTOFILL_FINISHED: {
      const { status } = action;
      return {
        ...state,
        autofillFinished: status,
      };
    }

    case CONVERT_FINISHED: {
      const { status } = action;
      return {
        ...state,
        convertFinished: status,
      };
    }


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/entities/io.js